<template>

    <div class="container-center">
        <el-form class="invite-form" label-width="140px" ref="form" :model="form">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="项目：" prop="project">
                        <el-input size="medium" v-model="form.projName" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="合同：" prop="contractConstruction">
                        <el-input size="medium" v-model="form.conName" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="产品及服务：" prop="serviceArray">
                        <el-select v-model="form.serviceArray" multiple  placeholder="请选择">
                            <el-option
                                v-for="item in productList"
                                :key="item.fid"
                                :label="item.fnameL2"
                                :value="item.fid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="年度：" prop="year">
                        <el-date-picker
                            v-model="form.year"
                            type="year"
                            value-format="yyyy"
                            placeholder="选择年">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="状态：" prop="status">
                        <el-select v-model="form.status" size="40" placeholder="请选择">
                            <el-option label="无" value=""></el-option>
                            <el-option label="申诉中" value="1"></el-option>
                            <el-option label="申诉通过" value="2"></el-option>
                            <el-option label="申诉退回" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="3" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="search" icon="el-icon-search">搜索
                    </el-button>
                </el-col>
            </el-row>

            <!-- <span>友情提示：若任一合同“单合同得分”低于{{this.toubiaofengzhishezhi}}分，则限制无法进行招投标业务，如需参加招投标，请及时发起投标资格恢复请求函。</span> -->

        </el-form>

        <div class="no-data-tip" v-if="tableData.length == 0"></div>

        <el-table v-else class="graphicTable" :data="tableData" style="width: 100%">
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column label="项目分期" show-overflow-tooltip prop="projectName"></el-table-column>
            <el-table-column label="合同名称" show-overflow-tooltip prop="conName"></el-table-column>
            <el-table-column label="合同金额（万元）" show-overflow-tooltip prop="signPrice"></el-table-column>
            <el-table-column label="评价年度" show-overflow-tooltip prop="year"></el-table-column>
            <el-table-column label="评价方案" show-overflow-tooltip prop="evalName"></el-table-column>
            <el-table-column label="成本得分" show-overflow-tooltip prop="costGrade">
                <template slot-scope="scope">
                    <span v-if="scope.row.costGrade">{{scope.row.costGrade}}</span>
                    <span v-else>—</span>
                </template>
            </el-table-column>
            <el-table-column label="工程得分" show-overflow-tooltip prop="engineerGrade">
                <template slot-scope="scope">
                    <span>{{scope.row.engineerGrade != null ? scope.row.engineerGrade : '—'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="设计得分" show-overflow-tooltip prop="designGrade">
                <template slot-scope="scope">
                    <span>{{scope.row.designGrade != null ? scope.row.designGrade : '—'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="客服得分" show-overflow-tooltip prop="customerGrade">
                <template slot-scope="scope">
                    <span>{{scope.row.customerGrade != null ? scope.row.customerGrade : '—'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="物业得分" show-overflow-tooltip prop="propGrade">
                <template slot-scope="scope">
                    <span>{{scope.row.propGrade != null ? scope.row.propGrade : '—'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总分" show-overflow-tooltip prop="avgScore">
                <template slot-scope="scope">
                    <span>{{scope.row.avgScore}}</span>
                </template>
            </el-table-column>
            <el-table-column label="申诉状态" show-overflow-tooltip prop="status">
                    <template slot-scope="scope">
                    <span v-if="scope.row.status=='1'" style="color: #409EFF;">申诉中</span>
                    <span v-else-if="scope.row.status=='2'" style="color: #409EFF;">申诉通过</span>
                    <span v-else-if="scope.row.status=='3'" style="color: #409EFF;">申诉退回</span>
                    <span v-else style="color: #409EFF;">无申诉</span>
                    </template>
                </el-table-column>
            <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                    <el-button type="text" @click="showConAppeal(scope.row,'do')">申诉</el-button>
                    <el-button type="text" @click="showConAppeal(scope.row,'view')">申诉详情{{scope.row.ssNum}}</el-button>
                    </template>
                </el-table-column>
            </el-table>

        <div class="block">
                <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pager.pageSize"
                :current-page="pager.pageNum"
                :total="pager.total"
                    prev-text="上一页"
                    next-text="下一页"
                    layout="total, prev, pager, next"
                    background>
                </el-pagination>
        </div>


        <el-dialog class="appeal-dialog" :title="conAppealTitle" width="65%" :visible.sync="conAppealShow" center>
            <el-form v-if="conAppealEditType=='do'" label-width="100px" :model="conAppealForm" :rules="rules">
                <el-form-item label="申诉说明：" prop="appealExplain">
                    <el-input placeholder="限500字以内" :maxlength="500" type="textarea" v-model="conAppealForm.appealExplain" size="medium" clearable></el-input>
                </el-form-item>
                <el-form-item label="附件：" prop="files">
                    <el-upload class="upload"
                               :action="uploadApi"
                               :on-success="handleChangeAchieve"
                               :on-error="uploadError"
                               :on-preview="handlePreview"
                               :on-remove="handleRemoveAchieve"
                               :before-remove="beforeRemove"
                               :before-upload="beforeUpload"
                               multiple
                               :limit="3"
                               :on-exceed="handleExceed"
                               :file-list="conAppealForm.files">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

                <el-form-item size="large">
                    <el-button type="primary" @click="conAppealStart">提交</el-button>
                    <el-button @click="conAppealShow = false">取消</el-button>
                </el-form-item>
            </el-form>

            <div v-if="conAppealEditType=='view'">
                <!-- 顶部信息 -->
                <el-card v-for="item in appealDetails" class="box-card">

                    <div slot="header" class="clearfix contract-data-top">
                        <p><span class="title">{{item.createDate}}</span></p>
                        <p class="status">
                            <span v-if="item.status=='1'" class="state-cont1">申诉中</span>
                            <span v-if="item.status=='2'" class="state-cont1">申诉通过</span>
                            <span v-if="item.status=='3'" class="state-cont1">申诉退回</span>
                        </p>
                    </div>

                    <div class="contract-data-detail">
                <el-row>
                            <el-col :span="6"><span class="icon-clock">申诉说明：{{item.appealExplain}}</span></el-col>
                </el-row>
                <el-row>
                            <el-col :span="6">
                                <span class="icon-man">附件：<ul>
                                <li v-for="li in item.files" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                                </ul>
                            </span>
                            </el-col>
                        </el-row>
                        </div>
                    <el-divider></el-divider>
                    <div v-if="item.status=='2' || item.status=='3'" class="contract-data-detail">
                        <el-row>
                            <el-col :span="6">
                                <span v-if="item.status=='2'" class="icon-clock">申诉结果：通过</span>
                                <span v-if="item.status=='2'" class="icon-clock">申诉结果：退回</span>
                    </el-col>
                </el-row>

                    <el-row>
                            <el-col :span="6"><span class="icon-man">申诉意见：{{item.appealAnswer}}</span></el-col>
                    </el-row>
                            </div>

                </el-card>

                <center>
                    <el-button type="primary" @click="showConAppeal(nowData,'do')">新增申诉</el-button>
                    <el-button @click="conAppealShow = false">取消</el-button>
                </center>
            </div>

        </el-dialog>

        <el-dialog :close-on-click-modal="false" :title="fillTitle + '评分查看'" :visible.sync="fillVisible" width="90%" :before-close="cancelFillDialog" class="fillDialog">
            <el-table :data="fillTabelData" size="mini" border  v-if="fillTitle == '成本'">
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="类型" prop="type"></el-table-column>
                <%--                <el-table-column label="扣分说明" prop="deductionNote"></el-table-column>--%>
                <el-table-column label="扣分" prop="costDeduction"></el-table-column>
            </el-table>
            <el-table :data="fillTabelData" size="mini" border v-else>
                <el-table-column label="评价维度" prop="types"></el-table-column>
                <el-table-column label="指标说明" prop="explain"></el-table-column>
                <el-table-column label="评分标准" prop="standard"></el-table-column>
                <el-table-column label="分值" prop="grade" width="50px"></el-table-column>
                <el-table-column label="打分" prop="score"></el-table-column>
                <el-table-column label="打分说明" prop="remark"></el-table-column>
            </el-table>
            <div class="footer-btns">
                <el-button @click="cancelFillDialog" size="mini">取 消</el-button>
                </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :title="fillTitle + '评分查看'" :visible.sync="engineerFillTable" width="90%" :before-close="cancelEnginnerFillDialog" class="fillDialog">
            <el-table :data="engineerFillTabelData" size="mini" border >
                <el-table-column label="评价类型" prop="evaluateType">
                    <template slot-scope="scope">
                        {{scope.row.evaluateType == 0 ? '支付评价' : scope.row.evaluateType == 1 ? '即时评价' : '结算评价'}}
                    </template>
                </el-table-column>
                <el-table-column label="评价主题" prop="title">
                    <template slot-scope="scope">
                        {{scope.row.title}}
                    </template>
                </el-table-column>
                <el-table-column label="分数" prop="flevel">
                    <template slot-scope="scope">
                        {{scope.row.flevel*20}}
                    </template>
                </el-table-column>
                <el-table-column label="评价时间" prop="inputDate">
                    <template slot-scope="scope">
                        {{moment(scope.row.inputDate).format('YYYY')}}年{{moment(scope.row.inputDate).format('MM')}}月{{moment(scope.row.inputDate).format('DD')}}日
                    </template>
                </el-table-column>
                <el-table-column label="评价人" prop="applyUserName">
                    <template slot-scope="scope">
                        {{scope.row.applyUserName}}
                    </template>
                </el-table-column>
            </el-table>
            <div class="footer-btns">
                <el-button @click="cancelEnginnerFillDialog" size="mini">取 消</el-button>
            </div>


        </el-dialog>

    </div>

</template>

<script>
    import filter from '@/filter'
    import banner from '@/assets/imgs/banner_invite.png'
    import util from '@/util'

    export default {
        name: 'detail-list',
        data () {
            return {
                toubiaofengzhishezhi: '0',
                loading: false,
                rules: {
                    appealExplain: [
                        {required: true, message: '请输入申诉说明', trigger: 'blur'}
                    ]
                },
                tableData: [],
                form: {
                    stockId: this.$root.stockId || '',
                    serviceArray: [],
                    projName: '',
                    conName: ''
                },
                pager: {
                    total: 0,
                    pageNum: 1,
                    pageSize: 10
                },
                productList: [],
                deductDetailShow: false,
                deductDetailTitle: '',
                detailForm: {
                    type: '',
                    name: ''
                },
                detailTable: [],
                detailPageer: {
                    total: 0,
                    pageNum: 1,
                    pageSize: 10
                },
                detailConId: '',
                conAppealShow: false,
                conAppealTitle: '',
                conAppealForm: {
                    stockId: '',
                    conId: '',
                    appealExplain: '',
                    files: []
                },
                appealDetails: [],
                appealEditType: 1,
                conAppealEditType: '',
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                nowData: null,
                fillVisible: false,
                fillTitle: '',
                fillTabelData: [],
                engineerFillTable:false,
                engineerFillTabelData:[]
            }
        },
        methods: {
            getPerevaList (from) {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                        this.form.from = typeof from != 'undefined'?from:'';
                        this.form.pageNum = this.pager.pageNum
                        this.form.pageSize = this.pager.pageSize
                        this.$http.post('/rest/api/ContractPerformance/supplierPerformanceScoreDetail', this.form).then((res) => {
                            loading.close()
                            if (res.data.result) {
                                this.tableData = res.data.value.list

                                this.pager.total = res.data.value.count
                                this.pager.pageNum = res.data.value.pageNo
                            } else {
                                this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                                loading.close()
                            }
                        })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
            handleCurrentChange (page) {
                this.pager.pageNum = page
                this.getPerevaList()
            },
            search () {
                this.pager.pageNum = 1
                this.form.from = '';
                this.getPerevaList(this.form.from)
            },
            showConAppeal (data,editType) {
                this.nowData = data;
                this.conAppealEditType = editType
                if (this.conAppealEditType == 'do') {
                    // 申诉发起
                    this.conAppealTitle = '申诉发起'
                    this.conAppealForm = {
                        conId: data.conId,
                        emEvaluateApprovalConId: data.id,
                        appealExplain: '',
                        files: []
                    }
                } else if(this.conAppealEditType == 'view') {
                    // 申诉详情
                    this.conAppealTitle = '申诉详情'
                    const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                    this.$http.get('/rest/api/ContractPerformance/getAllProducts').then((res) => {
                        if (res.data.result) {
                            this.productList = res.data.value || []
                            if(typeof(this.$refs.evalist) != undefined){
                                this.$refs.evalist.productList = res.data.value || []
                            }
                            if(typeof(this.$refs.detailList) != undefined){
                                this.$refs.detailList.productList = res.data.value || []
                            }
                        } else {
                            this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                        }
                    })
                    this.$http.post('/rest/api/ContractPerformance/getAppealDetails', {
                        emEvaluateApprovalConId: data.id
                    }).then((res) => {
                        loading.close()
                        if (res.data.result) {
                            this.appealDetails = res.data.value
                        } else {
                            this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                        }
                    })
                }
                this.conAppealShow = true
            },
            handleChangeAchieve (response, file, fileList) {
                this.conAppealForm.files = this.__getBaseFiles__(file, fileList)
            },
            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },
            handlePreview (file) {
                console.log(file)
            },
            handleRemoveAchieve (file, fileList) {
                this.conAppealForm.files = this.conAppealForm.files.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            beforeRemove (file) {
                return this.$confirm(`确定移除 ${file.name}？`)
            },
            beforeUpload (file) {
                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },
            handleExceed (files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
            },
            __getBaseFiles__ (file, fileList) {
                let fs = []
                fileList.forEach(function (item) {
                    console.log(item)
                    if (item.response) {
                        let f = item.response.basefiles[0]
                        item.fileOldName = f.fileoldname
                        item.name = f.fileoldname
                        item.fileName = f.filename
                        item.filePath = f.filepath
                        item.fileSize = f.filesize
                        item.fileType = f.filetype
                        item.sort = f.sort
                    }
                    fs.push(item)
                })
                console.log(fs)
                return fs
            },
            conAppealStart () {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.$http.post(`/rest/api/ContractPerformance/startAppeal`, this.conAppealForm).then((res) => {
                    loading.close()
                    if (res.data.result) {
                        this.getPerevaList(this.form.from)
                        this.$message({message: '提交成功', type: 'success'})
                        this.conAppealShow = false;
                    } else {
                        this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                    }
                })
            },
            showFillDialog(row, str, type) {
                if(row.ifNew == 2) return // ifNew = 2的时候不能填报，只能查看
                this.fillTabelData = []
                this.fillTitle = str
                if (str == '工程') {
                    this.$http.post('/rest/api/SingleContractPerformance/getConApprovalEvaluate',{ conId: row.conId}).then(res =>{
                        if(res.result){
                            this.engineerFillTabelData = res.data.value || []
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    this.engineerFillTable = true
                }else if(str == '成本') {
                    this.$http.post('/rest/api/SingleContractPerformance/costDeduction',{ conId: row.conId,type:'1' }).then(res =>{
                        if(res.data.result){
                            this.fillTabelData = res.data.value || []
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                } else {
                    this.$http.post('/rest/api/SingleContractPerformance/getEvaluateConItem',{ batchNo : row.batchId, conId: row.conId, type: type }).then(res =>{
                        if(res.data.result){
                            this.fillTabelData = res.data.value || []
                            this.fillTabelData.forEach(item => {
                                item.type = item.type || type
                            })
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                }
                this.fillVisible = true
            },
            cancelFillDialog() {
                this.fillVisible = false
            },
            cancelEnginnerFillDialog() {
                this.engineerFillTable = false
            }
        },
        created () {
        },
        mounted () {
            this.getPerevaList()
        },

    }

</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .invite-form {
        background: #F5F6F5;
        padding: 25px 10px 10px 10px;
        margin: 0 0 25px 0;
    }


    .appeal-dialog .el-dialog__header {
        background-color: #F4F5FA;
    }

    .box-card {
        margin: 30px 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/pfeva/PerformDetailList.vue